(() => {
  const initCarousel = (root) => {
    if (!root || root.dataset.vigoCarouselReady === 'true') return;

    const track = root.querySelector('[data-vigo-carousel-track]');
    const prev = root.querySelector('[data-vigo-carousel-prev]');
    const next = root.querySelector('[data-vigo-carousel-next]');
    if (!track) return;

    root.dataset.vigoCarouselReady = 'true';

    const getStep = () => {
      const first = track.querySelector('[data-vigo-carousel-slide]');
      if (!first) return Math.max(280, track.clientWidth * 0.75);
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };

    /*
      Important: do not capture pointer events on product/collection cards.
      Native horizontal scrolling remains available on touch devices, while
      desktop users use the arrow controls. This keeps every card/link fully clickable.
    */
    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initGalleryDialog = (scope) => {
    scope.querySelectorAll?.('[data-vigo-gallery-root]').forEach((root) => {
      if (root.dataset.vigoGalleryReady === 'true') return;
      root.dataset.vigoGalleryReady = 'true';

      const dialog = root.querySelector('[data-vigo-gallery-dialog]');
      const openers = root.querySelectorAll('[data-vigo-gallery-open]');
      const closer = root.querySelector('[data-vigo-gallery-close]');
      if (!dialog) return;

      const open = () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.body.classList.add('vigo-gallery-open');
      };

      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        document.body.classList.remove('vigo-gallery-open');
      };

      openers.forEach((button) => button.addEventListener('click', open));
      closer?.addEventListener('click', close);
      dialog.addEventListener('close', () => document.body.classList.remove('vigo-gallery-open'));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
    });
  };



  const initHeroCarousel = (scope) => {
    scope.querySelectorAll?.('[data-vigo-hero-carousel]').forEach((root) => {
      if (root.dataset.vigoHeroReady === 'true') return;
      root.dataset.vigoHeroReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-vigo-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-vigo-hero-dot]'));
      const prev = root.querySelector('[data-vigo-hero-prev]');
      const next = root.querySelector('[data-vigo-hero-next]');
      if (slides.length <= 1) {
        prev?.setAttribute('hidden', '');
        next?.setAttribute('hidden', '');
        return;
      }

      let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (index < 0) index = 0;

      const show = (nextIndex) => {
        const normalized = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === normalized));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === normalized));
        index = normalized;
      };

      let timer = null;
      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        const interval = Math.max(2000, Number(root.dataset.vigoHeroInterval || 4000));
        timer = window.setInterval(() => show(index + 1), interval);
      };
      const interact = (nextIndex) => {
        show(nextIndex);
        start();
      };

      prev?.addEventListener('click', () => interact(index - 1));
      next?.addEventListener('click', () => interact(index + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => interact(i)));

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      start();
    });
  };



  const initCardGalleries = (scope) => {
    scope.querySelectorAll?.('[data-vigo-card-gallery]').forEach((root) => {
      if (root.dataset.vigoCardGalleryReady === 'true') return;
      root.dataset.vigoCardGalleryReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-vigo-card-gallery-slide]'));
      const prev = root.querySelector('[data-vigo-card-gallery-prev]');
      const next = root.querySelector('[data-vigo-card-gallery-next]');
      if (slides.length <= 1) {
        prev?.setAttribute('hidden', '');
        next?.setAttribute('hidden', '');
        return;
      }

      let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (index < 0) index = 0;

      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });
      };

      const handle = (event, delta) => {
        event.preventDefault();
        event.stopPropagation();
        show(index + delta);
      };

      prev?.addEventListener('click', (event) => handle(event, -1));
      next?.addEventListener('click', (event) => handle(event, 1));
      show(index);
    });
  };

  const initAll = (context = document) => {
    context.querySelectorAll?.('[data-vigo-carousel-root]').forEach(initCarousel);
    initGalleryDialog(context);
    initHeroCarousel(context);
    initCardGalleries(context);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
